import { render, staticRenderFns } from "./IconGzl.vue?vue&type=template&id=66cbbe25"
import script from "./IconGzl.vue?vue&type=script&lang=js"
export * from "./IconGzl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports